import { render, staticRenderFns } from "./FormDesignRender.vue?vue&type=template&id=4ac9e6b5&scoped=true"
import script from "./FormDesignRender.vue?vue&type=script&lang=js"
export * from "./FormDesignRender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac9e6b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ac9e6b5')) {
      api.createRecord('4ac9e6b5', component.options)
    } else {
      api.reload('4ac9e6b5', component.options)
    }
    module.hot.accept("./FormDesignRender.vue?vue&type=template&id=4ac9e6b5&scoped=true", function () {
      api.rerender('4ac9e6b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/layout/FormDesignRender.vue"
export default component.exports